import React from "react";

const Footer = () => {
  return (
    <div>
      <section className="pt-6">
        <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex justify-between gap-2 border-t text-sm text-slate-400">
          <div>Copyright 2022 Tahmid Islam.</div>
          <div>
            <a
              href="https://www.linkedin.com/in/tahmidbd/"
              target="_blank"
              rel="noreferrer"
            >
              Linkedin
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
